<template src="./App.html"></template>
<style lang="scss" src="./App.scss"></style>

<script>


const default_layout = 'default';
import Vue from "vue";

// On Habile sign-in, HabileSignIn loads the customer and the category tree itself once logged in.
// Firing other API calls concurrently would overwrite the server session and lose the login.
const isHabileSignIn = (path) => path.endsWith('/habile-sign-in');

export default Vue.extend({
  name: 'AirFranceShopping',
  data() {
    return {
      currentLocal: null
    }
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + '-layout';
    },
    locale: {
      get() {
        return this.$store.getters.getCurrentLocale
      }
    }
  }, watch: {
    $route: 'getRoute',
  },
  mounted() {
    if (isHabileSignIn(window.location.pathname)) {
      return;
    }
    this.$store.dispatch('getMe');
  },
  methods: {
    getRoute() {
      this.currentRoute = this.$route.path
      if (this.$i18n.locale !== this.locale) {
        this.$store.dispatch('setCurrentLocal', {locale: this.$i18n.locale})
        document.getElementsByTagName("html")[0].lang = this.$i18n.locale;
        if (!isHabileSignIn(this.$route.path)) {
          this.$store.dispatch('getCategoryTree')
        }
      }
    }
  }

});
</script>
